import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './theme.css';
import './index.css';
import App from './App';
import { applyThemePreference, getThemePreference } from './theme';
import { PRERENDER_RELEASE_TIMEOUT_MS, releasePrerender } from './prerenderHandoff';

// Re-apply the stored theme before render. index.html loads
// public/theme-init.js before first paint; this covers any entry path that
// misses it.
applyThemePreference(getThemePreference());

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

// A pre-rendered page's snapshot is released by the live page as it mounts
// (prerenderHandoff.ts). This is the backstop for a page that never
// does, so the app itself can never stay hidden behind a snapshot.
window.setTimeout(releasePrerender, PRERENDER_RELEASE_TIMEOUT_MS);

// Register the minimal service worker so browsers offer "Install app"
// (manifest + icons + service worker + HTTPS/localhost are the criteria).
// Registered in development too: docker-compose serves the frontend with
// `npm start`, so gating on NODE_ENV would leave the default localhost:3000
// deployment non-installable. Safe because sw.js caches nothing — a caching
// worker is what breaks dev hot-reload, not the registration itself.
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      // BASE_URL is Vite's equivalent of CRA's PUBLIC_URL and always ends in
      // a slash, so the filename is appended directly.
      .register(`${import.meta.env.BASE_URL}sw.js`)
      .catch(() => {
        // Non-fatal: the app works identically without it.
      });
  });
}
